import httpRequest from "@/auth/http-client";
import { buildPaginationQuery, sanitizeFilters } from "@/helpers/request-helpers";
import {
  IServiceInterface,
  IServiceInterfaceCustomerSetting,
  ServiceInterfaceSettingsResult,
} from "@/interfaces/service-interface.interface";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

type SettingsApiItem = Partial<IServiceInterfaceCustomerSetting> & {
  Key?: string;
  Value?: string;
  Description?: string;
};

const normalizeSetting = (item: SettingsApiItem): IServiceInterfaceCustomerSetting => ({
  key: String(item.key ?? item.Key ?? ""),
  value: String(item.value ?? item.Value ?? ""),
  description: String(item.description ?? item.Description ?? ""),
});

class ServiceInterfaceService {
  private baseUrl = "api/v1.0/serviceinterface";

  async getAll(pagination: RequestPagination): Promise<PaginatedResponse<IServiceInterface>> {
    const paginationQuery = buildPaginationQuery(pagination);
    return httpRequest.get(`${this.baseUrl}?${paginationQuery}`);
  }

  async filter(
    filters: IFilter<IServiceInterface>[],
    pagination: RequestPagination
  ): Promise<PaginatedResponse<IServiceInterface>> {
    const paginationQuery = buildPaginationQuery(pagination);
    const filter = sanitizeFilters(filters);

    return httpRequest.post(`${this.baseUrl}/filter?${paginationQuery}`, { filter });
  }

  async getSettings(serviceInterfaceId: number): Promise<ServiceInterfaceSettingsResult> {
    const { data, status } = await httpRequest.getWithResponse<SettingsApiItem[]>(
      `${this.baseUrl}/${serviceInterfaceId}/settings`
    );

    if (status === 204) {
      return { status: "empty" };
    }

    const items = Array.isArray(data) ? data.map(normalizeSetting) : [];

    return { status: "ok", items };
  }
}

const serviceInterfaceService = new ServiceInterfaceService();
export default serviceInterfaceService;
